import { setError } from '../App/ErrorsActions';

import math from '../../util/math';
import customFieldsUtils from '../../util/customFieldsUtils';
import { getDefaultMarkBlockedValue } from '../../util/filterUtils';
import CalculationsWorker from '../../services/worker';
import _ from 'lodash';

export const ERROR = 'CTH_ERROR';
export const LOADING = 'CTH_LOADING';
export const LOADING_DETAILS = 'CTH_LOADING_DETAILS';
export const SUCCESS = 'CTH_SUCCESS';
export const SUCCESS_DETAILS = 'CTH_SUCCESS_DETAILS';

function getModeFromSeries(series) {
  let array = [];
  _.forEach(series, s => {
    array = array.concat(_.map(s.cards, c => Math.ceil(c.cycleTimeInMinutes / 1440)));
  });
  const mode = _.mode(array);
  return !!mode ? +mode : 0;
}

function calculateCTDistribution(data) {
  if (!data.percentiles || !data.percentiles.length) {
    return;
  }
  const fiftieth = _.find(data.percentiles, item => item.name == '50').value;
  const ninetyeigth = _.find(data.percentiles, item => item.name == '98').value;
  let ratio = ninetyeigth / fiftieth;

  let isFatTailed = false;
  if (ratio < 5.6) {
    const mode = getModeFromSeries(data.series);
    ratio = ninetyeigth / mode;
    isFatTailed = ratio >= 16;
  } else {
    isFatTailed = true;
  }

  return isFatTailed;
}

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

function detailsIsLoading(bool) {
  return {
    type: LOADING_DETAILS,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data
  };
}

export function successDetails(data) {
  const isFatTailed = calculateCTDistribution(data);
  return {
    type: SUCCESS_DETAILS,
    isFatTailed,
    data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const {
      chart,
      allCustomFields,
      excludeWeekends,
      workStart,
      workEnd,
      holidays,
      dates,
      enabledColors,
      cth
    } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : cth;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      let ctData = await worker.CycleTimeScatterPlot({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        markBlocked: filters.markBlocked && getDefaultMarkBlockedValue(data.app, selected),
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        color: true
      });
      dispatch(success(ctData));

      let cthData = await worker.CycleTimeHistogram({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        markBlocked: filters.markBlocked && getDefaultMarkBlockedValue(data.app, selected),
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: cth.timeUnit,
        percentiles: allFilters.allPercentileValues
      });
      dispatch(successDetails(cthData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getDetailsData(dates) {
  return async (dispatch, getState) => {
    dispatch(detailsIsLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const { chart, allCustomFields, excludeWeekends, workStart, workEnd, holidays, enabledColors, cth } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : cth;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      let cthData = await worker.CycleTimeHistogram({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        markBlocked: filters.markBlocked && getDefaultMarkBlockedValue(data.app, selected),
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: cth.timeUnit,
        percentiles: allFilters.allPercentileValues
      });
      dispatch(successDetails(cthData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
